
import React from 'react';
import TaskLabel from '../TaskLabel';

interface Label {
  type: 'urgent' | 'critical' | 'normal' | 'low';
}

interface CardLabelsProps {
  labels?: Label[];
}

export const CardLabels = ({ labels }: CardLabelsProps) => {
  if (!labels || labels.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-1 mb-3">
      {labels.map((label, i) => (
        <TaskLabel key={i} type={label.type} />
      ))}
    </div>
  );
};
